import React, {useEffect} from "react";
import axios from "axios";
import { handleError } from "../error/ErrorHandler";


const JoinNiceModuleSuccess = (props: any) => {

    useEffect(() => {
        console.log('success page!');
        setSmsYnSession();
        let params = new URLSearchParams(window.location.search);
        let telNo = params.get('telNo');
        alert('휴대본 본인인증에 성공하였습니다.')
        window.opener.postMessage(telNo);
        window.close();

    }, []);

    const setSmsYnSession = async () => {
        try {
            const res = await axios.get('/api/user/set/sms-yn');
            console.log('set sms-yn res', res);
        } catch(err) {
            handleError(err);
        }
    }
    return (
        <div className={'no-show'}>

            <p/><p/><p/><p/>
            <h2 className={'text-center'}>본인인증이 완료 되었습니다.</h2><br/><br/>
            <table className={'table-center'}>
                <tr>
                    <td>message</td>
                    <td>{props.sRtnMSG}</td>
                </tr>
                <tr>
                    <td>요청 번호</td>
                    <td>fff</td>
                </tr>
                <tr>
                    <td>나신평응답 번호</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>인증수단</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>성명</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>생년월일(YYYYMMDD)</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>성별</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>내/외국인정보</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>DI(64 byte)</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>CI(88 byte)</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>휴대폰번호</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>통신사</td>
                    <td>f</td>
                </tr>
                <tr>
                    <td>인증 후 결과값은 내부 설정에 따른 값만 리턴받으실 수 있습니다.<br/>
                        일부 결과값이 null로 리턴되는 경우 관리담당자 또는 계약부서(02-2122-4615)로 문의바랍니다.
                    </td>
                </tr>
            </table>
            <br/><br/><br/><br/><br/>
        </div>
    );
};

export default JoinNiceModuleSuccess;
